import * as constants from './constants';
import abbr from '../../../../config/abbr';
import { message } from 'antd';
import { apiGetPyzm, apiLoginTel, apisigncode } from '../../../../config/index';

export const toggleUserTelErr = (value, text) => ({
    type: constants.TOGGLE_USERTEL_ERR,
    value,
    text
})

export const togglePhonePyzmErr = (value, text) => ({
    type: constants.TOGGLE_PHONEPYZM_ERR,
    value,
    text
})

export const handleUserTelChange = (value) => ({
    type: constants.HANDLE_USERTEL_CHANGE,
    value
})

export const handlePhonePyzmChange = (value) => ({
    type: constants.HANDLE_PHONEPYZM_CHANGE,
    value
})

export const toggleSending = (value) => ({
    type: constants.TOGGLE_SENDING,
    value
})

export const setYzmBtnText = (text, value) => ({
    type: constants.SET_YZM_BTN_TEXT,
    text,
    value
})

export const setCountDownNum = (value) => ({
    type: constants.SET_COUNT_DOWN_NUM,
    value
})

export const setYzmSign = (value) => ({
    type: constants.SET_YZM_SIGN,
    value
})

//发送验证码倒计时120s
const settime = (countdown) => {
        if (countdown === 0) {
            return (dispatch) => {
                dispatch(toggleSending(false));
                dispatch(setYzmBtnText('发送验证码', false));
                dispatch(setCountDownNum(120));
            }
        } else {
            return (dispatch) => {
                dispatch(toggleSending(true));
                dispatch(setYzmBtnText(countdown + 's', true));
                countdown = countdown--;
                dispatch(setCountDownNum(countdown--));
                setTimeout(function() {
                    dispatch(settime(countdown));
                }, 1000)
            }
        }
    }
    //获取验签
    export const getsigncode = (tel, countdown) => {
        return (dispatch) => {
             //获取手机验证码
             dispatch(toggleSending(true));
             // eslint-disable-next-line
             let randomKey = '';
             apisigncode({}).then(response => {
                 if (response.code ==0) {
                     randomKey = response.data.randomKey;
                     console.log(randomKey)
                     dispatch(getPhonePyzm(tel, countdown,randomKey));
                     // dispatch(settime(countdown));
                     return;
                 } else {
                     dispatch(toggleSending(false));
                     message.error(response.msg);
                 }
             }).catch(error => {
                 console.log(error)
             })
         }
     }
     export const getPhonePyzm = (tel, countdown, randomKey) => {
        let timestamp = (new Date()).getTime();
        let formData = {
            sign: tel + ':' + timestamp + ':' + randomKey,
            type: 13
        }
        return (dispatch) => {
            //获取手机验证码
            dispatch(toggleSending(true));
            apiGetPyzm(formData).then(response => {
                if (response.code === abbr.okId) {
                    dispatch(setYzmSign(response.data));
                    dispatch(settime(countdown));
                    message.success('短信验证码已发送到你的手机，请查看哦！');
                    // this.getsigncode();
                    return;
                } else {
                    dispatch(toggleSending(false));
                    message.error(response.msg);
                }
            }).catch(error => {
                console.log(error)
            })
        }
    }
export const loginf = (tel, yzm, sign) => {
    let formData = {
        stuPhone: tel,
        msgCode: yzm,
        sign: sign
    }
    return (dispatch) => {
        dispatch(manuBtnClickF(true));
        apiLoginTel(formData).then(response => {
            if (response.code === abbr.okId) {
                let timestamp1 = new Date().getTime() + 1000 * 60 * 60 * 3;
                localStorage.setItem('lsisLogin', true);
                localStorage.setItem('userObj', JSON.stringify(response.data));
                localStorage.setItem('userPassTime', timestamp1);
                window.location.href = abbr.ipIndex;
            } else {
                message.error(response.msg);
            }
            dispatch(resetForm());
            dispatch(manuBtnClickF(true));
        }).catch(error => {
            console.log(error)
        })
    }
}

export const resetForm = () => ({
    type: constants.RESET_FORM,
})

const manuBtnClickF = (value) => ({
    type: constants.MANU_BTN_CLICK,
    value
})
